import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '../lib/queryKeys';
import { fetchLead } from '../api/leads';

/**
 * Single lead detail — enabled only when leadId is truthy.
 */
export function useLeadDetail (leadId) {
  return useQuery({
    queryKey: queryKeys.leads.detail(leadId),
    queryFn: () => fetchLead(leadId),
    enabled: Boolean(leadId),
  });
}
